//parse emoji to image
import emojiRegex from 'emoji-regex'
const unicodeEmojiRegex = emojiRegex();

import data from 'emoji-mart-vue-fast/data/facebook.json'
import { EmojiIndex } from 'emoji-mart-vue-fast'
let emojiIndex = new EmojiIndex(data)

export const emojiToHtml = function (emoji) {
  let style = `background-position: ${emoji.getPosition()};width: 24px; height: 24px;position:relative;display:inline-block;vertical-align:middle;`
  // The src="data:image..." is needed to prevent border around img tags.
  return `<span alt="${emoji.native}" contenteditable="false" class="emoji-set-facebook emoji-type-image" style="${style}"></span>`
}

export const wrapEmoji = function (text) {
  return text.replace(unicodeEmojiRegex, function(match, offset) {
    const before = text.substring(0, offset)
    if (before.endsWith('alt="') || before.endsWith('data-text="')) {
      // Emoji inside the replaced <img>
      return match
    }
    // Find emoji object by native emoji.
    let emoji = emojiIndex.nativeEmoji(match)
    if (!emoji) {
      // Can't find unicode emoji in our index
      return match
    }
    // See `emojiToHtml` function above.
    return emojiToHtml(emoji)
  })
}

export const parseMessageEmojis = function (data) {
  try {
    if (typeof data == 'string') {
      data = wrapEmoji(data)
    } else if (typeof data == 'object') {
      if (data.text) {
        data.text = parseMessageEmojis(data.text)
      }

      if (data.gallery) {
        for (var element of data.gallery) {
          //parse title
          element.title = parseMessageEmojis(element.title)
          //parse subtitle
          element.subtitle = parseMessageEmojis(element.subtitle)
          if (element.buttons) {
            for (var button of element.buttons) {
              // parse button
              button.title = parseMessageEmojis(button.title)
            }
          }
        }
      }

      if (data.quick_replies) {
        for (var qr of data.quick_replies) {
          qr.title = parseMessageEmojis(qr.title)
        }
      }

      if (data.buttons) {
        for (var button of data.buttons) {
          // parse button
          button.title = parseMessageEmojis(button.title)
        }
      }
    }
  } catch (e) {
    console.error(e);
  }

  return data
}
